module.exports = __webpack_public_path__ + "static/media/Inter-UI-Black.28b144c2.woff2";